module.exports = __webpack_public_path__ + "static/media/address-c-red-icon.6bfce151.svg";